import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 1h1v4H2V1zm4 1h16v2H6V2zm4 18h12v2H10v-2zm12-9H8v2h14v-2zM3 10H2v4h1v-4zm1 0h1v4H4v-4zm-1 9H2v4h1v-4zm1 0h1v4H4v-4zm3 0H6v4h1v-4z" }));
export default createSvgIcon(iconPath, "OrderedList");
//# sourceMappingURL=OrderedListIcon.js.map